import { render } from "./tcadd.vue?vue&type=template&id=3e1632ef&scoped=true"
import script from "./tcadd.vue?vue&type=script&lang=js"
export * from "./tcadd.vue?vue&type=script&lang=js"

import "./tcadd.vue?vue&type=style&index=0&id=3e1632ef&lang=scss&scoped=true"
import "./tcadd.vue?vue&type=style&index=1&id=3e1632ef&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1632ef"]])

export default __exports__